import toast from './toast';
import login from './login';
import torrent from './torrent';
import search from './search';
import adding from './adding';
import deleting from './deleting';
import setting from './setting';
import archive from "./archive";
import stat from './stat';
import { combineReducers, Action } from 'redux';
import { ThunkAction } from 'redux-thunk';


const rootReducer = combineReducers({
  toast,
  login,
  torrent,
  search,
  adding,
  deleting,
  setting,
  archive,
  stat,
});


export type RootState = ReturnType<typeof rootReducer>
export default rootReducer;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  null,
  Action<string>
>